<div id="unityContainer" [style.visibility]="isHidden ? 'hidden' : 'visible'" class="unity-container"></div>
